<script setup>
import { ref } from 'vue';
import { useLabStore } from '@/stores/lab';
import { storeToRefs } from 'pinia';
// Import the component
import LabProfileForm from '@/components/Lab/LabProfileForm';

const labStore = useLabStore();
const { active: lab } = storeToRefs(labStore);

const labProfileFormRef = ref(null);

const save = () => {
    if (labProfileFormRef.value) {
        labProfileFormRef.value.save(); // Call the save method in LabProfileForm
    }
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.management_title',{ 'what' : 'Lab Profile' }) }}</template>
    <div>
        <h1 class="text-2xl font-bold mb-4">{{ $t("label.lab_profile") }}</h1>
        <LabProfileForm
            ref="labProfileFormRef"
            :lab="lab" />

        <div class="mt-6">
            <StyledSaveButton :hide-cancel="true" @save="save" />
        </div>
    </div>
</MainContentLayout>
</template>
